import { Badge } from "@mantine/core";
import { PortalGrantState } from "../../../services/admin/portalAccess.service";

interface PortalGrantStateBadgeProps {
  state: PortalGrantState;
}

const STATE_COLORS: Record<PortalGrantState, string> = {
  invited: "gray",
  active: "teal",
  revoked: "red",
};

const STATE_LABELS: Record<PortalGrantState, string> = {
  invited: "Invited",
  active: "Active",
  revoked: "Revoked",
};

export function PortalGrantStateBadge({ state }: PortalGrantStateBadgeProps) {
  return (
    <Badge
      color={STATE_COLORS[state]}
      variant="light"
      size="sm"
      style={{ flexShrink: 0 }}
      styles={{ label: { overflow: "visible" } }}
    >
      {STATE_LABELS[state]}
    </Badge>
  );
}
